export enum SettleOperationType {
    MARKETPLACE_ITEM_CREATION,
    MARKETPLACE_ITEM_EDITION,
    MARKETPLACE_ITEM_REMOVAL
}

export enum SettleOperationState {
    LOADING,
    SETTLED
}